import React from 'react';
import cn from 'classnames';

import styles from './index.module.css';

const SquareRadioButton = ({
  label,
  input,
  radioValue,
  meta: { touched, error },
}) => {
  const isError = touched && error;
  return (
    <div
      className={cn(
        styles.button,
        { 
          [styles.active]: input.value === radioValue,
          [styles.error]: isError,
        }
      )}
      onClick={() => input.onChange(radioValue)}
    >
      {label}
    </div>
  )
}

export default SquareRadioButton
